// import { useState } from "react";
// import logo from "../logo.png";
// import "./Navbar.css";

// export default function Navbar({
//   search,
//   setSearch,
//   setPage,
//   showCategory,
//   setShowCategory,
//   categories = [],
//   setSelectedCategory,
//   cartCount,
//   notifications = [],
//   language,
//   setLanguage,
// }) {

// const [showNotifications,setShowNotifications] = useState(false);


// const content = {
//   en:{
//     cart:"Cart",
//     noNotifications:"Get 20% off on all beauty products this week."
//   },

//   ur:{
//     cart:"کارٹ",
//     noNotifications:"اس ہفتے تمام بیوٹی پراڈکٹس پر بیس %  چھوٹ حاصل کریں۔"
//   }
// };



// const categoryNames = {

// "Kitchen Essentials":"کچن کی ضروریات",
// "Household Needs":"گھریلو ضروریات",
// "Jewelry and Cosmetic Organizers":
// "جیولری اور کاسمیٹک آرگنائزر",
// "Decor Essentials":"سجاوٹ کے لوازمات",
// "Personal Care":"ذاتی نگہداشت",
// "Bathroom Essentials":"باتھ روم کی ضروریات",
// "Kids and Babies Section":
// "بچوں اور نومولود کا سیکشن"

// };



// const getCategoryName=(cat)=>{

// return language==="ur"
// ? categoryNames[cat] || cat
// : cat;

// };



// return (

// <header className="navbar-container">



// {/* Logo */}

// <div
// className="logo-container"
// onClick={()=>setPage("home")}
// >

// <img
// src={logo}
// className="logo-img"
// alt="logo"
// />


// <h2>
// OnlinePK
// </h2>

// </div>





// {/* Search */}

// <div className="search-box">


// <input

// className="search"

// type="text"

// placeholder={
// language==="en"
// ?"Search products..."
// :"پروڈکٹس تلاش کریں..."
// }

// value={search}

// onChange={(e)=>setSearch(e.target.value)}

// />


// <span className="search-icon">
// 🔍
// </span>


// </div>






// {/* Menu */}


// <nav className="nav-links">


// <a onClick={()=>setPage("home")}>

// {language==="en"?"Home":"ہوم"}

// </a>



// <a onClick={()=>setPage("products")}>

// {language==="en"?"Products":"پروڈکٹس"}

// </a>





// <div className="category-menu">


// <a
// onClick={()=>setShowCategory(!showCategory)}
// >

// {
// language==="en"
// ?"Products Categories ▼"
// :"پروڈکٹس کیٹیگریز ▼"
// }


// </a>




// {
// showCategory && (

// <div className="dropdown">


// {
// categories.map((cat,index)=>(


// <p

// key={index}

// onClick={()=>{

// setSelectedCategory(cat);
// setPage("category");
// setShowCategory(false);

// }}

// >


// {getCategoryName(cat)}


// </p>


// ))

// }



// </div>

// )

// }




// </div>





// <a onClick={()=>setPage("store")}>

// {language==="en"?"Store":"اسٹور"}

// </a>





// <a onClick={()=>setPage("contact")}>

// {language==="en"?"Contact":"رابطہ"}

// </a>




// </nav>







// {/* Right */}


// <div className="nav-right">



// <select

// className="language-select"

// value={language}

// onChange={(e)=>setLanguage(e.target.value)}

// >


// <option value="en">
// English
// </option>


// <option value="ur">
// اردو
// </option>


// </select>







// {/* Notification */}


// <div className="notification-icon"

// onClick={()=>
// setShowNotifications(!showNotifications)
// }

// >


// 🔔



// {
// notifications.length>0 &&

// <span className="notification-count">

// {notifications.length}

// </span>

// }


// </div>





// {
// showNotifications && (

// <div className="notification-dropdown">


// {

// notifications.length>0 ?


// notifications.map((n)=>(


// <div
// className="notification-item"
// key={n.id}
// >


// <b>
// {n.title}
// </b>


// <p>
// {n.description}
// </p>


// </div>


// ))


// :

// <div className="notification-item">

// {content[language].noNotifications}

// </div>


// }


// </div>

// )

// }





// <button

// className="cart-btn"

// onClick={()=>setPage("cart")}

// >


// 🛒

// {content[language].cart}



// <span className="cart-count">

// {cartCount}

// </span>


// </button>





// </div>



// </header>

// )

// }
import { useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import "./Navbar.css";
import logo from "../logo.png";

export default function Navbar({
  search = "",
  setSearch = () => {},
  cartCount = 0,
  notifications = [],
  language = "en",
  setLanguage = () => {},
}) {
  const navigate = useNavigate();
  const [showNotifications, setShowNotifications] = useState(false);

  return (
    <header className="navbar">
      {/* Logo */}
      <div className="navbar-logo" onClick={() => navigate("/")}>
        <img src={logo} alt="Logo" />
      </div>

      {/* Search */}
      <div className="navbar-search">
        <input
          type="text"
          placeholder={
            language === "ur"
              ? "پروڈکٹس تلاش کریں..."
              : "Search products..."
          }
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* Navigation */}
      <nav className="navbar-links">
        <NavLink to="/">Home</NavLink>
        <NavLink to="/products">Products</NavLink>
        <NavLink to="/stores">Stores</NavLink>
        <NavLink to="/contact">Contact</NavLink>
      </nav>

      {/* Right Side */}
      <div className="navbar-actions">
        <select
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
        >
          <option value="en">EN</option>
          <option value="ur">اردو</option>
        </select>

        <button
          className="icon-btn"
          onClick={() => setShowNotifications(!showNotifications)}
        >
          🔔
          {notifications.length > 0 && (
            <span className="badge">{notifications.length}</span>
          )}
        </button>

        <button
          className="cart-btn"
          onClick={() => navigate("/cart")}
        >
          🛒
          {/* <span className="badge">{cartCount}</span> */}
          {
 cartCount > 0 &&
 <span className="badge">
   {cartCount}
 </span>
}
        </button>
      </div>

      {/* Notification Dropdown */}
      {showNotifications && (
        <div className="notification-box">
          {notifications.length === 0 ? (
            <p>No Notifications</p>
          ) : (
            notifications.map((item, index) => (
              <div key={index} className="notification-item">
                {item}
              </div>
            ))
          )}
        </div>
      )}
    </header>
  );
}